import React from 'react';
import CatalogPage from './CatalogPage';

const ComicsPageSimple = () => <CatalogPage forcedCategory="comic" title="Comics" />;

export default ComicsPageSimple;
